import AccountInfo from "state/AccountInfo";
import BaseReporter from "landings/Analytics/BaseReporter";
import { GoogleTagManager } from "utils/GoogleTagManager";

declare global {
    interface Window {
        __PixGTagDataLayer: any[];
        $$PixGTagID: string;
        $$PixGTagReport(type: string, eventName: string, data?: object);
    }
}

/**
 * GA4新版本GTagManger
 * GTag接入文档：{@link https://support.google.com/analytics/answer/9310895?hl=zh-Hans&ref_topic=11192706}
 * 自动搜集事件配置参考：{@link https://support.google.com/analytics/answer/9234069}
 * GTag数据上报限制：{@link https://support.google.com/analytics/answer/9267744?hl=zh-Hans}
 */
export default class GTagReporter extends BaseReporter {
    private _config(initialData: object) {
        window.$$PixGTagReport("config", window.$$PixGTagID, initialData);
    }

    report(eventName: string, data: object = {}) {
        window.$$PixGTagReport("event", eventName, data);
        GoogleTagManager.shared.report(eventName, data as any);
    }

    setProfile(locale: string, accountInfo: AccountInfo) {
        const profile = BaseReporter.FormateLoginProfile(locale, accountInfo);
        this._config(profile);
    }

    reset() {}

    updateProfile(userId: string, profile: {}) {}
}
